import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 代理店-グループ一覧取得
export async function getSaleCompanyGroups(id: string) {
  try {
    const path = "saleCompanyGroups";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 代理店-グループ編集
export async function putSaleCompanyGroup(editData: EditDataDifine) {
  try {
    const path = "saleCompanyGroup";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 代理店-グループ削除
export async function deleteSaleCompanyGroup(id: string) {
  try {
    const path = "saleCompanyGroup";
    const response = await axios.delete(CONST.apiUrl + path, {
      params: { id },
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 代理店-グループ登録
export async function postSaleCompanyGroup(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyGroup";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 体制図一括更新（グループCRUD + アカウント所属変更）
export async function putSaleCompanyChart(payload: {
  sale_company_id: number;
  groups: {
    id: number | null;
    sale_company_group_name: string;
    action: "keep" | "create" | "update" | "delete";
    tempId: string | null;
  }[];
  account_assignments: {
    account_id: number;
    sale_company_group_id: number | null | string;
  }[];
}) {
  try {
    const path = "saleCompanyChart";
    const response = await axios.put(CONST.apiUrl2 + path, {
      bodys: payload,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
